import { Migration } from '~/models/migration';
import { Image } from '~/models/image';

export const migrationService = {
	fetch: async (): Promise<Migration.Model | null> => {
		const params = {
			fields: ['*', 'photo.*', 'photo.directus_files_id.*'],
		};

		try {
			const response = await $fetch<
				Omit<Migration.Model, 'photo'> & { photo: { directus_files_id: Image.Model }[] }
			>(Migration.api, {
				method: 'POST',
				body: { params },
			});

			/** Resolve images */
			const images = response.photo.reduce((acc, { directus_files_id }) => {
				acc.push(directus_files_id);
				return acc;
			}, [] as Image.Model[]);

			return { ...response, photo: images };
		} catch (error) {
			console.error('Failed to fetch Migration:', error);

			return null;
		}
	},
};
